import { isNavigationMenuOpenState } from '@modules/application/atoms';
import ChecklistIcon from '@mui/icons-material/Checklist';
import FolderIcon from '@mui/icons-material/Folder';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useGetMe } from '@utils/useGetMe';
import { useResponsive } from '@utils/useResponsive';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useAtom } from 'jotai';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getTenantIdentifier } from '../../../../utils/getTenantIdentifier';

export const mobileBottomNavigationHeight = 54;

export const MobileBottomNavigation: React.FC = () => {
  const { formatMessage } = useIntl();
  const { isMobile } = useResponsive();
  const { projectId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const tenantIdentifier = getTenantIdentifier();
  const [, setIsNavigationMenuOpen] = useAtom(isNavigationMenuOpenState);
  const { isExternalUser } = useGetMe();

  const shouldRender = isMobile && tenantIdentifier && !projectId && !isExternalUser;

  const activeTab = useMemo(() => {
    if (location.pathname.includes('/tasks')) {
      return 'tasks';
    }
    else if (location.pathname.includes('/projects')) {
      return 'projects';
    }

    return 'more';
  }, [location.pathname]);

  if (!shouldRender) {
    return null;
  }

  const handleChange = (_: React.SyntheticEvent, value: string) => {
    if (value === 'more') {
      setIsNavigationMenuOpen(true);
      return;
    }

    if (!tenantIdentifier) {
      return;
    }

    const targets: Record<string, string> = {
      projects: `/${tenantIdentifier}/projects`,
      tasks: `/${tenantIdentifier}/tasks`
    };

    const targetPath = targets[value];

    if (targetPath && targetPath !== location.pathname) {
      navigate(targetPath);
    }
  };

  return (
    <Paper
      
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar,
        height: mobileBottomNavigationHeight
      }}
    >
      <BottomNavigation value={activeTab} onChange={handleChange} showLabels>
        <BottomNavigationAction value="projects" label={formatMessage({ id: 'Projects' })} icon={<FolderIcon />} />
        <BottomNavigationAction value="tasks" label={formatMessage({ id: 'Tasks' })} icon={<ChecklistIcon />} />
        <BottomNavigationAction value="more" label={formatMessage({ id: 'More' })} icon={<MoreHorizIcon />} />
      </BottomNavigation>
    </Paper>
  );
};

